const ID_PREFIX = 'social-link-not-found';
const BASE = import.meta.env.VITE_BASE ?? '/';

export function renderNotFound(): string {
  return `
  <main class="not-found ids-container" data-testid="${ID_PREFIX}-main">
    <div class="mh-auto">
      <div>
        <h1 data-testid="${ID_PREFIX}-title">Error 404</h1>
        <p data-testid="${ID_PREFIX}-text">Ops, não encontramos a página buscada</p>
      </div>
      <img
        src="${BASE}assets/icon-lighthouse.svg"
        alt="icone de farol"
        aria-hidden="true"
        data-testid="${ID_PREFIX}-image"
      />
    </div>
  </main>`;
}
